// extracted by mini-css-extract-plugin
module.exports = {"view-counterview-linked-story-container":"story-attributes_view-counterview-linked-story-container__2JKV4"};